import React from 'react';
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import MenuContent from './MenuContent';
import { Button } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../components/AuthContext'; // Import useAuth hook
import { useInstitution } from '../../components/InstitutionContext';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import { useLocation } from 'react-router-dom';
import { SitemarkIcon } from '../internals/components/CustomIcons';
const drawerWidth = 240;

const Drawer = styled(MuiDrawer)({
  width: drawerWidth,
  flexShrink: 0,
  boxSizing: 'border-box',
  [`& .${drawerClasses.paper}`]: {
    width: drawerWidth,
    boxSizing: 'border-box',
  },
});

export default function SideMenu({ mobileOpen, onClose }) {
  const { user, logout } = useAuth();
  const { setSelectedInstitution } = useInstitution();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    setSelectedInstitution('');
    await logout();
    navigate('/');
  };
  
  return (
    <Drawer
      variant={mobileOpen ? 'temporary' : 'permanent'}
      open={mobileOpen} // Show drawer only when `mobileOpen` is true on small screens
      onClose={onClose} // Close drawer on mobile
      ModalProps={{ keepMounted: true }} // Improve performance on mobile
      sx={{
        display: { xs: mobileOpen ? 'block' : 'none', md: 'block' },
        [`& .${drawerClasses.paper}`]: {
          backgroundColor: 'background.paper',
        },
      }}
    >
      {/* Sidebar Header */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          mt: 'calc(var(--template-frame-height, 0px) + 4px)',
          p: 1.5,
        }}
      >
        <Stack direction="row" alignItems="center" gap={1}>
          <Box sx={{ lineHeight: 0 }}>
            <SitemarkIcon />
          </Box>
          <Typography variant="h6" fontWeight="bold" noWrap>
            Medskool
          </Typography>
        </Stack>
      </Box>

      {/* Navigation Links */}
      <MenuContent />

      {/* User Info or Sign In/Sign Up */}
      <Box sx={{ p: 2, borderTop: '1px solid', borderColor: 'divider' }}>
        {user ? (
          <Stack gap={1}>
            <Stack direction="row" gap={1} alignItems="center">
              <Avatar
                alt={user.username || 'Guest User'}
                src={user.avatar || '/static/images/avatar/placeholder.jpg'}
                sx={{ width: 36, height: 36 }}
              />
              <Typography variant="body1" fontWeight="bold" noWrap>
                {user.username}
              </Typography>
            </Stack>
            <Button
              variant="outlined"
              fullWidth
              startIcon={<LogoutRoundedIcon />}
              onClick={handleLogout}
            >
              Logout
            </Button>
          </Stack>
        ) : (
          <Stack direction="row" gap={1} justifyContent="center">
            <Button
              component={Link}
              to="/sign-in"
              state={{ from: location.pathname }}
              variant="outlined"
              size="small"
            >
              Log In
            </Button>

            <Button component={Link} to="/sign-up" variant="contained" size="small">
              Sign Up
            </Button>
          </Stack>
        )}
      </Box>
    </Drawer>
  );
}
